module.exports = __WEBPACK_EXTERNAL_MODULE_46__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types","root":"PropTypes"}
// module id = 46
// module chunks = 0